import makeGetVideoEntity from "selectors/makeGetVideoEntity";
import { createSelector } from "reselect";
import pick from "lodash/pick";

export const makeGetVideoFocalPoint = () => {
  const getVideoEntity = makeGetVideoEntity();

  return createSelector([getVideoEntity], (videoEntity) => {
    let focalPoint = pick(videoEntity, "focalX", "focalY", "height", "width");

    if (videoEntity.isVertical && focalPoint.width > focalPoint.height) {
      focalPoint = {
        ...focalPoint,
        height: focalPoint.width,
        width: focalPoint.height,
      };
    }
    return focalPoint;
  });
};

export default makeGetVideoFocalPoint;
